<template>
  <div v-if="visible" class="modal-overlay" @click="closeModal">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h3>장비 반출</h3>
        <button @click="closeModal" class="close-btn">&times;</button>
      </div>
      
      <div class="modal-body">
        <div class="equipment-info">
          <h4>{{ tag.devicename || 'N/A' }}</h4>
          <p><strong>Tag MAC:</strong> {{ tag.tag_mac }}</p>
          <p><strong>현재 위치:</strong> {{ tag.taglocation || 'N/A' }}</p>
        </div>

        <form @submit.prevent="submitExport">
          <div class="form-group">
            <label for="exportType">반출 유형 *</label>
            <select id="exportType" v-model="formData.export_type" required>
              <option value="">선택하세요</option>
              <option value="maintenance">수리중</option>
              <option value="transfer">타 병동</option>
            </select>
          </div>

          <div class="form-group" v-if="formData.export_type === 'transfer'">
            <label for="destinationWard">목적지 병동 *</label>
            <select id="destinationWard" v-model="formData.destination_ward" required>
              <option value="">선택하세요</option>
              <option value="73">73병동</option>
              <option value="74">74병동</option>
              <option value="83">83병동</option>
              <option value="other">그외</option>
            </select>
          </div>

          <div class="form-group">
            <label for="exportReason">반출 사유</label>
            <textarea 
              id="exportReason" 
              v-model="formData.export_reason" 
              rows="3" 
              placeholder="반출 사유를 입력하세요"
            ></textarea>
          </div>

          <div class="form-group">
            <label for="returnDate">반입 예정일</label>
            <input 
              type="datetime-local" 
              id="returnDate" 
              v-model="formData.return_date"
            >
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button @click="closeModal" class="btn btn-secondary">취소</button>
        <button @click="submitExport" class="btn btn-primary" :disabled="!isFormValid">
          반출 등록
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EquipmentExportModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tag: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        export_type: '',
        destination_ward: '',
        export_reason: '',
        return_date: ''
      }
    };
  },
  computed: {
    isFormValid() {
      return this.formData.export_type && 
             (this.formData.export_type !== 'transfer' || this.formData.destination_ward);
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.formData = {
        export_type: '',
        destination_ward: '',
        export_reason: '',
        return_date: ''
      };
    },
    closeModal() {
      this.$emit('close');
    },
    async submitExport() {
      if (!this.isFormValid) {
        alert('필수 항목을 모두 입력해주세요.');
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const requestData = {
          tag_mac: this.tag.tag_mac,
          export_type: this.formData.export_type,
          destination_ward: this.formData.destination_ward || null,
          export_reason: this.formData.export_reason || null,
          return_date: this.formData.return_date || null
        };

        const response = await axios.post('/api/equipment/export', requestData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.data.success) {
          alert('장비 반출이 등록되었습니다.');
          this.$emit('exported', response.data);
          this.closeModal();
        } else {
          alert(response.data.message || '반출 등록에 실패했습니다.');
        }

      } catch (error) {
        console.error('반출 등록 오류:', error);
        if (error.response && error.response.data && error.response.data.message) {
          alert(error.response.data.message);
        } else {
          alert('반출 등록 중 오류가 발생했습니다.');
        }
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #e9ecef;
  color: #333;
}

.modal-body {
  padding: 24px;
}

.equipment-info {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}

.equipment-info h4 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #333;
}

.equipment-info p {
  margin: 4px 0;
  font-size: 14px;
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group select,
.form-group textarea,
.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-group select:focus,
.form-group textarea:focus,
.form-group input:focus {
  outline: none;
  border-color: #4e73df;
  box-shadow: 0 0 0 3px rgba(78, 115, 223, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-group input[type="datetime-local"] {
  padding: 10px 12px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-primary {
  background: #4e73df;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #3a5bc7;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 20px;
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 16px;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
}
</style>
